module.exports = __webpack_public_path__ + "static/media/news-press-i.7ae71f4d.png";